import { render, staticRenderFns } from "./Reviewables.vue?vue&type=template&id=129ac646"
import script from "./Reviewables.vue?vue&type=script&lang=js"
export * from "./Reviewables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports